"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _gift = require("../../store/gift/gift.selector");

var SenderGiftLanguage = function SenderGiftLanguage(_ref) {
  var className = _ref.className;
  var gl = (0, _reactRedux.useSelector)(_gift.getSenderGiftLanguage);
  return /*#__PURE__*/_react.default.createElement("span", {
    className: className
  }, gl);
};

var _default = SenderGiftLanguage;
exports.default = _default;